export const SPREMNIK_DOKUMENATA = 'dokumenti';
export const NAJVECA_DATOTEKA = 10 * 1024 * 1024;
export const VRSTE_DOKUMENATA = {
  gdpr_privola: 'GDPR privola',
  plan: 'Plan / nacrt',
  zapisnik: 'Zapisnik',
  ostalo: 'Ostali dokumenti',
};
export const PRIHVACENE_DATOTEKE =
  '.pdf,.jpg,.jpeg,.png,.webp,application/pdf,image/jpeg,image/png,image/webp';
const NASTAVCI = {
  'application/pdf': 'pdf',
  'image/jpeg': 'jpg',
  'image/png': 'png',
  'image/webp': 'webp',
};
export function putanjaDokumenta(korisnikId, id, mime) {
  if (
    !NASTAVCI[mime] ||
    !/^[0-9a-f-]{36}$/i.test(id) ||
    !/^[0-9a-f-]{36}$/i.test(korisnikId)
  )
    throw new Error('Neispravna putanja dokumenta.');
  return `${korisnikId}/${id}.${NASTAVCI[mime]}`;
}
export function prikazVelicine(bajtovi) {
  return bajtovi < 1024 * 1024
    ? `${Math.ceil(bajtovi / 1024)} KB`
    : `${(bajtovi / 1024 / 1024).toFixed(1)} MB`;
}
export async function prepoznajDatoteku(datoteka) {
  if (!datoteka.size || datoteka.size > NAJVECA_DATOTEKA)
    throw new Error(
      'Datoteka mora biti manja od 10 MB i ne smije biti prazna.',
    );
  const b = new Uint8Array(await datoteka.slice(0, 12).arrayBuffer());
  const pocinje = (...n) => n.every((v, i) => b[i] === v);
  if (pocinje(37, 80, 68, 70, 45)) return 'application/pdf';
  if (pocinje(255, 216, 255)) return 'image/jpeg';
  if (pocinje(137, 80, 78, 71, 13, 10, 26, 10)) return 'image/png';
  if (
    pocinje(82, 73, 70, 70) &&
    b[8] === 87 &&
    b[9] === 69 &&
    b[10] === 66 &&
    b[11] === 80
  )
    return 'image/webp';
  throw new Error('Odaberi PDF ili fotografiju u formatu JPG, PNG ili WEBP.');
}
export async function pripremiDokument(datoteka) {
  let mime = await prepoznajDatoteku(datoteka);
  let sadrzaj = datoteka;
  let naziv = datoteka.name.replace(/[\u0000-\u001f/\\]/g, '_').slice(0, 240);
  if (mime === 'application/pdf')
    naziv = (naziv.replace(/\.[^.]*$/, '') || 'dokument') + '.pdf';
  if (mime.startsWith('image/')) {
    let slika;
    try {
      slika = await createImageBitmap(datoteka, {
        imageOrientation: 'from-image',
      });
    } catch {
      throw new Error(
        'Fotografiju nije moguće otvoriti. Odaberi drugu snimku ili PDF.',
      );
    }
    try {
      if (slika.width * slika.height > 60000000)
        throw new Error(
          'Fotografija je prevelikih dimenzija. Odaberi manju snimku.',
        );
      const omjer = Math.min(1, 2400 / Math.max(slika.width, slika.height));
      const platno = document.createElement('canvas');
      platno.width = Math.round(slika.width * omjer);
      platno.height = Math.round(slika.height * omjer);
      const kontekst = platno.getContext('2d');
      kontekst.fillStyle = '#fff';
      kontekst.fillRect(0, 0, platno.width, platno.height);
      kontekst.drawImage(slika, 0, 0, platno.width, platno.height);
      // Nova slika ne prenosi EXIF ni GPS metapodatke kamere.
      sadrzaj = await new Promise((razrijesi) =>
        platno.toBlob(razrijesi, 'image/jpeg', 0.9),
      );
      if (!sadrzaj) throw new Error('Priprema fotografije nije uspjela.');
      mime = 'image/jpeg';
      naziv = naziv.replace(/\.[^.]+$/, '') + '.jpg';
    } finally {
      slika.close();
    }
  }
  const otisak = await crypto.subtle.digest(
    'SHA-256',
    await sadrzaj.arrayBuffer(),
  );
  return {
    id: crypto.randomUUID(),
    datoteka: sadrzaj,
    mime,
    izvorni_naziv: naziv || 'dokument.pdf',
    velicina: sadrzaj.size,
    sha256: Array.from(new Uint8Array(otisak), (b) =>
      b.toString(16).padStart(2, '0'),
    ).join(''),
  };
}

// Datoteke se šalju nakon zapisa kućanstva. Ponovni pokušaj preskače taj zapis.
export async function spremiUzPrivole({
  spremljeni,
  naSpremi,
  privole,
  datumPrivole,
  naPrivole,
  naEvidentirano,
  naNapredak,
}) {
  const rezultat = spremljeni || (await naSpremi());
  naEvidentirano(rezultat);
  if (privole.length)
    await naPrivole({
      datoteke: privole,
      kucanstvoId: rezultat.id,
      vrsta: 'gdpr_privola',
      naziv: 'GDPR privola',
      datumPrivole: datumPrivole || null,
      naNapredak,
    });
  return rezultat;
}
